import React, { useState } from "react";
import { useQuery } from "@apollo/client";
import { useHistory } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { GET_LECTION_QUERY } from "../../queries/queries";
import { FINISH_SECTION } from "../../queries/mutations";
import { REGISTER_CONTEST } from "../../queries/mutations";
import Loading from "../loading";
import Error from "../error";
import PlayLection from "./play-lection";
import DisclaimerModal from "./disclaimer-modal";

const PlayLectionContainer = ({
  classes,
  match: {
    params: { lectionId },
  },
}) => {
  let history = useHistory();

  const [finishSection] = useMutation(FINISH_SECTION, {
    onCompleted({ finishSection }) {
      if (finishSection.userHistory) {
        history.push(`/lections/success/${lection.id}`);
      } else {
        history.push(`/courses/${lection.courseId}`);
      }
    },
  });

  const [registerContest] = useMutation(REGISTER_CONTEST, {
    onCompleted({ registerContest }) {
      if (registerContest.user) {
        setSuccessMessage("Erfolgreich Registriert");
      } else {
        setErrorMessage("Bei der Registrierung ist etwas schief gelaufen");
      }
    },
  });

  const handleFinish = () => {
    const userId = localStorage.getItem("user_id");
    finishSection({
      variables: { userId: userId, sectionId: lection.id },
    });
  };

  const handleRegisterContest = () => {
    registerContest();
  };

  window.onmessage = function(e) {
    if (e.data === "finished") {
      handleFinish();
    } else if (e.data === "competition") {
      handleRegisterContest();
    } else if (e.data === "failed") {
      history.push(`/lections/failed/${lection.id}`);
    } else if (e.data === "back") {
      history.push(`/courses/${lection.courseId}`);
    } else if (e.data === "disclaimer") {
      setDisclaimerOpen(true);
    } else if (e.data === "conditions") {
    }
  };

  const [disclaimerOpen, setDisclaimerOpen] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [successMessage, setSuccessMessage] = useState<string>('');

  const { loading, error, data } = useQuery(GET_LECTION_QUERY, {
    variables: { id: lectionId },
    fetchPolicy: "no-cache",
  });

  if (loading) return <Loading />;
  if (error) return <Error />;


  const lection = data.section;

  const { pharmacy, email, firstName, lastName } = data.currentUser;

  const iFrameUrl =
    lection.iframeUrl +
    encodeURI(
      `?apoId=${pharmacy.oneKeyId}&email=${email}&first_name=${firstName}&last_name=${lastName}`
    );

  return (
    <>
      <DisclaimerModal
        open={disclaimerOpen}
        handleClose={() => setDisclaimerOpen(false)}
        lection={lection}
      />
      <PlayLection
        errorMessage={errorMessage}
        successMessage={successMessage}
        iFrameUrl={iFrameUrl}
        popup={false}
      />
    </>
  );
};

export default PlayLectionContainer;
